import {CLMimeType, MediaStatus} from './media.types';

const mediaRenderingStatusQueryInterval = 30000;

const mediaStatusToUiNameMap: Record<MediaStatus, string> = {
  [MediaStatus.Rendered]: 'Pending',
  [MediaStatus.Completed]: 'Rendered',
  [MediaStatus.Failed]: 'Failed',
  [MediaStatus.Pending]: 'Pending',
  [MediaStatus.PendingToDeletion]: 'Pending to Deletion',
  [MediaStatus.SyncingWithPlatform]: 'Pending',
  [MediaStatus.Canceled]: 'Canceled',
  [MediaStatus.PendingApproval]: 'Pending Approval',
  [MediaStatus.All]: 'Total',
};

const imageMediaMimeTypes = [
  CLMimeType.WEBP,
  CLMimeType.APNG,
  CLMimeType.PNG,
  CLMimeType.JPG_SHORT,
  CLMimeType.JPG,
  CLMimeType.SVG,
  CLMimeType.GIF,
];
const videoMediaMimeTypes = [CLMimeType.MP4, CLMimeType.WEBM, CLMimeType.GIF, CLMimeType.MOV];
const fontMediaMimeTypes = [
  CLMimeType.TTF,
  CLMimeType.OTF,
  CLMimeType.TTC,
  CLMimeType.WOFF,
  CLMimeType.WOFF2,
];
const audioMediaMimeTypes = [CLMimeType.MP3, CLMimeType.MPEG, CLMimeType.WAV, CLMimeType.FLAC, CLMimeType.OGG, CLMimeType.M4A];
const subtitlesMediaMimeTypes = [CLMimeType.SRT];

export {
  mediaRenderingStatusQueryInterval,
  mediaStatusToUiNameMap,
  imageMediaMimeTypes,
  videoMediaMimeTypes,
  audioMediaMimeTypes,
  fontMediaMimeTypes,
  subtitlesMediaMimeTypes,
};
